import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import DeckAssembler from '../components/DeckAssembler';
import TemplateDeckBuild from '../components/deck/TemplateDeckBuild';
import MeetingDeckLibrary from '../components/deck/MeetingDeckLibrary';

// Chat creates decks. Meeting Prep opens and edits saved presentations.
export default function MeetingPrepDeck() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const templateDeck = params.get('templateDeck');
  const composition = params.get('composition');
  const startChat = () => navigate('/');
  const openDeck = id => navigate(`/decks/meeting-prep?composition=${id}`);
  if (templateDeck && /^\d+$/.test(templateDeck)) return <TemplateDeckBuild key={templateDeck} deckId={templateDeck} />;
  if (composition && /^\d+$/.test(composition)) return <DeckAssembler
    key={composition} initialCompositionId={composition} onOpenDeck={openDeck}
    onCloseDeck={() => navigate('/decks/meeting-prep')} onStartChat={startChat} />;
  // Historical navigation state must not reopen the retired intake wizard.
  if (location.state?.noticeDeck || location.state?.conversationDeck || location.state?.partListDeck) {
    return <Navigate to="/" replace />;
  }
  return <MeetingDeckLibrary onStartChat={startChat} onOpenDeck={openDeck} />;
}
